const styles = () => ({
  root: {
    minWidth: 280,
    fontFamily:
      "'Avenir Next Medium', 'Avenir Next', Avenir, Helvetica, Arial, sans-serif",
  },

  section: {
    padding: '12px 15px 8px',
    borderBottom: '1px solid rgba(155,173,188,0.30)',
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },

  personDetailsText: {
    display: 'flex',
    flexDirection: 'column',
  },

  name: {
    color: '#27282A',
    fontWeight: 500,
    fontSize: 15,
  },

  email: {
    color: '#596168',
    fontSize: 14,
    lineHeight: '15px',
    marginBottom: 4,
  },

  editProfile: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 500,
    color: '#148CFC',
    '& svg': {
      opacity: 0,
      transition: 'ease opacity 0.1s',
      position: 'relative',
      left: 4,
    },
    '&:hover svg': {
      opacity: 1,
    },
  },

  editProfileButton: {
    background: 'white',
    textTransform: 'unset',
    letterSpacing: 0,
    fontWeight: 500,
    fontSize: 14,
    margin: 12,
    padding: '1px 20px',
    minHeight: 34,
    borderRadius: 6,
  },

  sectionHeading: {
    display: 'flex',
    fontWeight: 600,
    fontSize: 14,
    color: '#9BADBC',
    paddingLeft: 15,
    marginBottom: 5,
    alignItems: 'center',
  },

  sectionHeadingActions: {
    color: '#36C480',
    marginLeft: 'auto',
    alignSelf: 'flex-end',
    paddingRight: 15,
    '&:hover': {
      color: '#36C480',
      opacity: 0.8,
    },
  },

  sectionHeadingPlus: {
    width: 10,
    height: 10,
    marginRight: 5,
  },

  selectedConfig: {
    display: 'flex',
    justifySelf: 'center',
    marginLeft: 'auto',
    marginRight: 10,
    alignSelf: 'center',
    '&:hover svg path': {
      fill: 'rgb(80, 80, 80)',
    },
    '&:active svg path': {
      fill: 'rgb(120, 120, 120)',
    },
  },

  actions: {
    color: '#596168',
    fontWeight: 500,
    padding: '10px 0 6px',
  },

  actionLink: {
    color: '#596168',
    fontSize: 14,
    height: 28,
    width: '100%',
    paddingLeft: 15,
    paddingRight: 20,
    paddingBottom: 0,
    paddingTop: 5,
    lineHeight: 1.2,
    display: 'flex',
    flexDirection: 'row',
    '&:hover': {
      color: '#596168',
      background: 'rgba(225,233,240,0.25)',
    },
    '& svg': {
      marginRight: 8,
      marginTop: -1,
      justifySelf: 'center',
    },
  },

  logoutLinkIcon: {
    position: 'relative',
    left: 1,
  },
});

export default styles;
